import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from '@src/design-system/dialog';
import { ReminderTemplateCard } from '@src/features/reminders/components/reminder-template-card';
import { ViewReminderTemplateDetails } from '@src/shared/features/reminders/dialogs/view-reminder-template-details';
import type { TReminderTemplate } from '@src/shared/types/reminder-template';

type ReminderTemplatesCardsViewProps = {
  templates: TReminderTemplate[];
};

export function ReminderTemplatesCardsView({
  templates,
}: ReminderTemplatesCardsViewProps) {
  return (
    <div className='grid flex-1 grid-cols-[repeat(auto-fill,minmax(350px,1fr))] grid-rows-[repeat(auto-fill,minmax(170px,1fr))] gap-4'>
      {templates.map((reminderTemplate) => (
        <Dialog key={reminderTemplate.id}>
          <DialogTrigger>
            <ReminderTemplateCard {...reminderTemplate} />
          </DialogTrigger>
          <DialogContent className='flex w-full max-w-[78%] flex-col overflow-hidden'>
            <ViewReminderTemplateDetails reminderTemplate={reminderTemplate} />
          </DialogContent>
        </Dialog>
      ))}
    </div>
  );
}
